import React, { useContext, useState } from "react";
import { css } from "emotion";
import { BuildContext } from "../../../context/BuildSpotlightState";
import { textSizes, colors, boxStyles } from "../../../styles/theme";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Back5 from "-!react-svg-loader!../../../assets/icons/back5.svg";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Pause from "-!react-svg-loader!../../../assets/icons/pause.svg";

const AudioContent = () => {
  const { fileUrl } = useContext(BuildContext);
  const { headline, ctaText, secondaryColor, stage, primaryColor } = useContext(
    BuildContext
  );
  const [isPaused, setIsPaused] = useState(true);

  let _audio;

  const handlePlayPause = () => {
    if (isPaused) {
      const allAudio = document.getElementsByTagName("audio");
      for (let i = 0; i < allAudio.length; i++) {
        allAudio[i].pause();
      }

      _audio.play();
      setIsPaused(false);
    } else {
      _audio.pause();
      setIsPaused(true);
    }
  };

  return (
    <div className={container}>
      {stage !== 3 ? (
        <div className="content">
          <p className="headline" style={{ color: secondaryColor }}>
            {headline}
          </p>
          {fileUrl && (
            <a
              onClick={handlePlayPause}
              className={"spotlt_button" + (isPaused ? "" : " pause")}
              style={{ borderColor: secondaryColor, color: secondaryColor }}
            >
              {isPaused ? "LISTEN" : "PAUSE"}
              <div
                className="spotlt_play-icon-circle"
                style={{
                  display: "inline-block",
                  backgroundColor: secondaryColor,
                }}
              >
                <div
                  className="spotlt_icon"
                  style={{
                    borderColor: `transparent transparent transparent ${primaryColor}`,
                  }}
                />
              </div>
              <audio
                src={fileUrl}
                ref={(element) => (_audio = element)}
                onEnded={() => setIsPaused(true)}
              />
            </a>
          )}
        </div>
      ) : (
        <div className="player">
          <div
            className="progress-bar"
            style={{ backgroundColor: secondaryColor }}
          />
          <div className="player-content">
            <div className="time-row">
              <p style={{ color: secondaryColor }}>0:10</p>
              <p style={{ color: secondaryColor }}>-1:24</p>
            </div>
            <div className="controls-row">
              <div className="side-left">
                <div className="dot-box">
                  <div style={{ backgroundColor: secondaryColor }} />
                  <div style={{ backgroundColor: secondaryColor }} />
                  <div style={{ backgroundColor: secondaryColor }} />
                </div>
              </div>
              {ctaText && (
                <div
                  className="button"
                  style={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  {ctaText}
                </div>
              )}
              <div className="side-right">
                <div className="audio-controls">
                  <style>
                    {`.svg-icon * {
                      fill: ${secondaryColor};
                    }`}
                  </style>
                  <Back5 className="svg-icon" />
                  <Pause className="svg-icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AudioContent;

const container = css`
  width: 100%;
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .headline {
      color: white;
      font-size: ${textSizes.intermediate};
      padding-right: 10px;
      max-width: 200px;
      word-break: break-all;
    }

    .spotlt_button {
      background-color: transparent;
      cursor: pointer;
      margin-left: 30px;
      transition-duration: 0.2s;
      font-weight: bold;
      font-size: 16px;
      letter-spacing: 1.33px;
      display: flex;
      align-items: center;
      height: 35px;
      align-self: center;
      min-width: 60px;
      color: rgb(255, 255, 255);
      border-radius: 3px;
      padding: 3px 18px;
      border-width: 2px;
      border-style: solid;
      border-color: rgb(255, 255, 255);
      border-image: initial;
      min-width: 98px;
      justify-content: center;
      box-sizing: border-box;
      font-size: 11px;
      padding: 0px 6px;
      margin-left: 10px;
      height: 28px;
      flex-shrink: 1;
      text-transform: uppercase;

      .spotlt_play-icon-circle {
        display: inline-block;
        height: 18px;
        width: 18px;
        margin-left: 8px;
        position: relative;
        transition-duration: 0.2s;
        border-radius: 50%;

        .spotlt_icon {
          display: block;
          will-change: border-width;
          cursor: pointer;
          left: 6px;
          position: absolute;
          top: 4px;
          transition: all 0.2s ease 0s;
          border-style: solid;
          border-width: 5px 0px 5px 8px;
        }
      }

      &.pause {
        .spotlt_icon {
          height: 10px;
          transform: translateX(-1px);
          border-style: double;
          border-width: 0px 0px 0px 8px;
        }
      }
    }
  }
  .player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    
    .progress-bar {
      position: absolute;
      top: 0;
      left: 0;
      width: 30%;
      height: 100%;
      opacity: 0.1;
    }
    
    .player-content {
      position: relative;
      z-index: 5;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      
      .time-row {
        position: absolute;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 2px;
        
        p {
          font-weight: bold;
          font-size: 10px;
        }
      }

      .controls-row {
        min-height: 35px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .side-left {
          flex: 1;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .side-right {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .dot-box {
          padding-left: 10px;
          display: flex;
          justify-content: space-around;
          align-items: center;

          div {
            border-radius: 50%;
            margin: 2px;
            height: 6px;
            width: 6px;
          }
        }
        .button {
          color: white;
          padding: 3px 12px;
          border-radius: 4px;
          border: 1px solid white;
          white-space: nowrap;
          font-size: ${textSizes.normal};
          text-transform: uppercase;
          font-weight: 500;
          cursor: pointer;
        }

        .audio-controls {
          width: 70px;
          padding-right: 10px;
          display: flex;
          align-items: center;
          justify-content: space-around;
        }
      }
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .content {
      justify-content: center;

      .headline {
        max-width: unset;
      }
    }
  }
`;
